import { useNavigate } from 'react-router-dom'
import { ArrowRightIcon } from '@heroicons/react/20/solid'
import { services } from '../data/services'

export default function Services() {
  const navigate = useNavigate()

  return (
    <section id="services" className="scroll-mt-20 bg-white py-14 sm:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-bold tracking-tight text-indigo-600 sm:text-5xl">
            Consulting &amp; Services
          </h2>
          <p className="mt-4 text-lg text-gray-500">
            Simplify your payment ecosystem with our ready-to-use L3 Transit App.
          </p>
        </div>

        <div className="mx-auto mt-16 grid grid-cols-1 gap-5 md:grid-cols-3">
          {services.map((service) => (
            <div
              key={service.number}
              onClick={() => navigate(`/services/${service.id}`)}
              className="group cursor-pointer rounded-3xl bg-gray-50 p-8 transition-all duration-300 hover:bg-indigo-500 hover:shadow-lg"
            >
              <div className="flex items-start justify-between">
                <span className="text-4xl font-bold leading-none text-gray-300 transition-colors duration-300 group-hover:text-white">
                  {service.number}
                </span>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-200 transition-colors duration-300 group-hover:bg-white">
                  <ArrowRightIcon className="h-5 w-5 text-gray-500 transition-all duration-300 group-hover:-rotate-45 group-hover:text-gray-800" />
                </span>
              </div>

              <h3 className="mt-10 text-2xl font-bold text-gray-900 transition-colors duration-300 group-hover:text-white">
                {service.name}
              </h3>

              <p className="mt-4 text-base leading-7 text-gray-500 transition-colors duration-300 group-hover:text-indigo-100">
                {service.shortDesc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
